import GeneralConfig from '@/config/general';

// eslint-disable-next-line import/prefer-default-export
export function strapiImageUrl(url: string) {
  if ((url && url.startsWith('http://')) || (url && url.startsWith('https://'))) {
    return url.replace(GeneralConfig.cdnReplacementSrc, GeneralConfig.cdnReplacementDst);
  }
  return `${GeneralConfig.strapiMedia}${url}`;
}
